import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import {
  APIHandler,
  DataHandler,
  Email,
  Register,
  StorageHandler,
  Forgot,
} from 'C4';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];

  Array.from(inputs)
    .forEach((input) => {
      inputArray.push(input);
    });

  return inputArray.every(val => val.checkValidity() === true);
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: {
        email: '',
        reg_email: '',
        reg_first_name: '',
        reg_last_name: '',
        reg_agency_name: '',
        reg_state: '',
        reg_mobile_phone: '',
        reg_city: '',
        reg_address: '',
        reg_zip_code: '',
        reg_country: '',
        reg_custom_1: '',
      },
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      redirect: '',
      appId: 0,
      admission_message: '',
      verified_message: '',
      resend_link: '',
    };

    document.body.classList.add('no-scroll');

    StorageHandler.exists(storageKeys.user)
      .then((res) => {
        if (this.props.path !== '/logout' && res) {
          this.setState({ redirect: '/main' });
        } else {
          StorageHandler.removeKeys(userKeys);
        }
      });

    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.registerHandlerSSO = this.registerHandlerSSO.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.signUpRoute = this.signUpRoute.bind(this);
    this.forgotPasswordRoute = this.forgotPasswordRoute.bind(this);
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId()
      .then((id) => {
        this.setState({ appId: id });
      });
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    document.querySelector('.form__message').style.color = 'red';
    document.querySelector('.form__message').style.opacity = 1;
    document.querySelector('.form__message').style.color = 'black';
  }

  backHandler() {
    this.setState({
      display: 'login',
      message: '',
    });
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  signUpRoute() {
    // Event snippet for 2022 - US - Campaign Specialist Program - Pageview on https://www.canadaspecialistprogram.com/login: Please do not remove.
    if (window.location.hostname === 'canadaspecialistprogram.us' || window.location.hostname === 'www.canadaspecialistprogram.us'
    || window.location.hostname === 'canadaspecialist.us ' || window.location.hostname === 'www.canadaspecialist.us'
    || window.location.hostname === 'canadaspecialistprogram.com' || window.location.hostname === 'www.canadaspecialistprogram.com' 
    || window.location.hostname === 'canadaspecialist.com' || window.location.hostname === 'www.canadaspecialist.com' || window.location.hostname === 'localhost') { 
      window.gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-6628166/csp/2022-0+standard',
        event_category: 'access',
        event_label: 'login'
      });
    }
    
    this.setState({ display: 'registerPassword' });
  }

  forgotPasswordRoute() {
    this.setState({ display: 'forgot' });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) {
      StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    }
    document.body.classList.remove('no-scroll');
    if (customRedir) {
      this.setState({ redirect: customRedir });
    } else {
      this.setState({ redirect: '/main' });
    }
  }

  async loginHandler(event, email = this.state.userInput.email, password = this.state.userInput.password) {
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      event.preventDefault();

      const exists = await StorageHandler.exists(storageKeys.user);
      if (!exists) {
        const response = await APIHandler.loginUser(email, password);

        if (response.error || response.success === false) {
          submit.disabled = false;
          toast.error(response.message, {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return;
        }

        StorageHandler.save(storageKeys.accessToken, response.access_token);
        StorageHandler.save(storageKeys.refreshToken, response.refresh_token, response.expires_in);
        this.setAnim('loadingAnim', true);
        submit.disabled = true;

        const appId = await DataHandler.matchAppId();
        const user = await APIHandler.getUser(appId, response.access_token);
        if (Object.keys(user).length > 0) {
          this.login(user, true);
          return;
        }
      }
      // TODO test
      StorageHandler.load(storageKeys.user)
        .then((userInfo) => { // Loads userInfo from localStorage
          submit.disabled = false;
          this.login(userInfo, false);
        });
    } else {
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
    }
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value;
    this.setState({ userInput: input });
  }

  registerHandler() {
    if (checkInputValidity()) {
      this.setAnim('loadingAnimRegister', true);
      const info = this.state.userInput;
      
      let lang = localStorage.getItem('lang');
      lang = JSON.parse(lang);
      lang = lang.rawData;
      
      let marketing = false;
      if (info.opt_in_marketing) {
        marketing = true;
      }

      let registerObject = {
        first_name: info.reg_first_name,
        last_name: info.reg_last_name,
        agency_name: info.reg_agency_name,
        state: info.reg_state,
        country: lang.code,
        marketing_opt_in: marketing,
      };
      
      // German
      if (window.location.hostname === 'canadaspecialistprogram.de' || window.location.hostname === 'www.canadaspecialistprogram.de') {   
        registerObject = {
          first_name: info.reg_first_name,
          last_name: info.reg_last_name,
          agency_name: info.reg_agency_name,
          state: info.reg_state,
          city: info.reg_city,
          state: info.reg_state,
          address: info.reg_address,
          zip_code: info.reg_zip_code,
          country: info.reg_country,
          marketing_opt_in: marketing,
          custom_1: info.reg_custom_1
        };
      }
      
      DataHandler.matchAppId()
        .then((appId) => {

          // Mexico
          if (appId === 831) {
            registerObject.mobile_phone = info.reg_mobile_phone;
          }
        
          APIHandler.setUser(info.reg_email, this.state.appId, registerObject)
            .then(() => {
              APIHandler.getUserOld(appId, info.reg_email)
                .then(newUser => newUser);
            });
        });
    } else {
      toast.error('Please fill in all the required fields', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
    }
  }

  async registerHandlerSSO(event) {
    console.log(checkInputValidity());
    if (!checkInputValidity()) {
      toast.error('Please fill in all the required fields', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
      return
    }

    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    this.setAnim('loadingAnimRegister', true);

    const name = `${this.state.userInput.reg_first_name} ${this.state.userInput.reg_last_name}`;
    const email = this.state.userInput.reg_email;
    const company = this.state.userInput.reg_agency_name;
    const password = this.state.userInput.reg_password;
    const passwordConfirm = this.state.userInput.reg_passwordConfirm;
    const country = this.state.userInput.reg_country;

    if ((window.location.hostname === 'canadaspecialistprogram.de' || window.location.hostname === 'www.canadaspecialistprogram.de') && country === '') {
      toast.error('Country needs to be filled in.', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (!password) {
      toast.error('Password needs to be at least 8 characters.', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password !== passwordConfirm) {
      toast.error('The passwords you entered do not match', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password.length < 8) {
      toast.error('Password needs to be at least 8 characters.', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    APIHandler.registerSSOUser(name, email, company, password, passwordConfirm)
      .then((SSOUser) => {
        if (SSOUser.success === false) {
          toast.error('This email address already exists or is invalid. Please try with another email address or login to your account.', {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          submit.disabled = false;
          this.setAnim('loadingAnimRegister', false);
        } else {
          // Old school register
          this.registerHandler();
          toast.success(SSOUser.message, {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          submit.disabled = false;
          this.setAnim('loadingAnimRegister', false);
          
          window.setTimeout(() => {
            window.location.href = '/login?register=success';
          }, 10000);
        }
      });
  }

  forgotHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { email } = this.state.userInput;
    this.setAnim('loadingAnimForgot', true);
    APIHandler.forgotPassword(email)
      .then((res) => {
        if (res.status !== 200) {
          this.setAnim('loadingAnimForgot', false);
          submit.disabled = false;
          toast.error('The email address you entered doesn\'t exist.', {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          this.setAnim('loadingAnimForgot', false);
          submit.disabled = false;
          toast.success(res.message.concat('\n You will be redirect to the login page in 10 seconds'), {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          window.setTimeout(() => {
            window.location.href = '/login';
          }, 10000);
        }
      });
  }

  resendHandler() {
    APIHandler.resendVerificationLink(this.state.resend_link)
      .then((res) => {
        if (res.success) {
          toast.success(res.message, {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.setState({ resend_link: '' });
        }
      });
  }

  render() {
    const {
      animation,
      display,
      message,
      redirect,
      userInput,
    } = this.state;

    return (
      <form className="login__form">
        <ToastContainer
          draggablePercent={70}
        />
        {display === 'login' && <Email
          submit={this.loginHandler}
          defaultVal={userInput.email}
          change={this.changeHandler}
          loadingAnim={animation.loadingAnim}
          signUpRoute={this.signUpRoute}
          forgotPasswordRoute={this.forgotPasswordRoute}
        />}
        {display === 'forgot' && <Forgot
          back={this.backHandler}
          defaultVal={userInput.email}
          submit={this.forgotHandler}
          change={this.changeHandler}
          loadingAnimRegister={animation.loadingAnimForgot}
        />}

        {display === 'registerPassword' && <Register
          passwordField
          back={this.backHandler}
          submit={this.registerHandlerSSO}
          change={this.changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />}

        <h3 className="form__message">{message}</h3>

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <p className="legal">
          {i18n.translate('loginScreen.tAndC.agree')}
          <span
            role="button"
            tabIndex={-1}
            data-fancybox="privacy"
            data-type="iframe"
            href="https://travpromobile.com/privacy_policy.html"
          >{i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>
          {i18n.translate('loginScreen.tAndC.and')}
          <span
            role="button"
            tabIndex={0}
            data-fancybox="terms"
            data-type="iframe"
            href="https://travpromobile.com/terms_of_use.html"
          >{i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>.
        </p>
        <SweetAlert
          html
          onConfirm={() => {
            this.setState({ admission_message: '' });
          }}
          show={!!this.state.admission_message}
          confirmButtonText="Ok"
          text={this.state.admission_message}
        />
        <SweetAlert
          html
          title="Email not Verified:"
          onConfirm={() => {
            this.setState({ verified_message: '' });
          }}
          onCancel={() => {
            this.setState({ verified_message: '' });
            this.resendHandler();
          }}
          show={!!this.state.verified_message}
          confirmButtonText="Ok"
          cancelButtonText="Resend email"
          showCancelButton
          text={this.state.verified_message}
        />
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
